import { CircularProgress, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@material-ui/core'
import useStyles from './styles'
import React, { useEffect } from 'react'
import { useSetorService } from 'hooks/useSetorService'
import { Autocomplete } from '@material-ui/lab'
import { useState } from 'react'
import { useCallback } from 'react'

export const FormEncaminhamentoVestigio = (props) => {
  const { form, handleChange, multiple, vestigios } = props
  const setorService = useSetorService()
  const [processandoSetores, setProcessandoSetores] = useState(false)
  const [setores, setSetores] = useState([])
  const classes = useStyles()

  const situacoesVests = [
    { label: 'Vestígio para entrega ao destino final', slug: 'PARA_ENTREGA' },
    { label: 'Vestígio para armazenamento', slug: 'PARA_ARMAZENAMENTO' },
  ]

  const fetchSetores = useCallback(async () => {
    const response = await setorService.listarSetoresAsync(setProcessandoSetores)
    setSetores(response)
  }, [])

  useEffect(() => {
    fetchSetores()
  }, [fetchSetores])

  return (
    <Grid container className={classes.container} spacing={3}>
      <Grid item md={12} sm={12} xs={12} lg={12}>
        <Typography className={classes.gridTitle}>
          <b>FORMULÁRIO DE ENCAMINHAMENTO DE VESTÍGIO</b>
        </Typography>
      </Grid>

      {processandoSetores ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <>
          {!multiple && (
            <>
              <Grid item md={12} sm={12} xs={12} lg={12}>
                <TextField
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  label="NÚMERO DO LACRE"
                  name="lacre"
                  onChange={(e) => handleChange('lacre', e.target.value)}
                  value={form.lacre}
                />
              </Grid>
              <Grid item container md={12} sm={12} xs={12} className={classes.fieldGroup}>
                <Grid item md={12} sm={12} xs={12}>
                  <Typography variant="body2">TIPO DA EMBALAGEM</Typography>
                </Grid>
                <FormControl component="fieldset" fullWidth>
                  <RadioGroup aria-label="tipo-embalagem" name="tipoEmbalagem" value={form.tipoEmbalagem || null} onChange={(e) => handleChange('tipoEmbalagem', e.target.value)} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <FormControlLabel value="SACO LACRE" control={<Radio />} label={<Typography variant="body2">SACO LACRE</Typography>} />
                    <FormControlLabel value="PLÁSTICO" control={<Radio />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
                    <FormControlLabel value="ENVELOPE PAPEL" control={<Radio />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
                    <FormControlLabel value="CAIXA" control={<Radio />} label={<Typography variant="body2">CAIXA</Typography>} />
                    <FormControlLabel value="AUSENTE" control={<Radio />} label={<Typography variant="body2">AUSENTE</Typography>} />
                    <FormControlLabel value="OUTRO" control={<Radio />} label={<Typography variant="body2">OUTRO</Typography>} />
                  </RadioGroup>
                </FormControl>
                {form.tipoEmbalagem === 'OUTRO' && (
                  <Grid item md={12} sm={12} xs={12}>
                    <TextField
                      label="OUTRO TIPO DE EMBALAGEM"
                      name="outroTipoEmbalagem"
                      variant="outlined"
                      value={form.outroTipoEmbalagem}
                      onChange={(e) => handleChange('outroTipoEmbalagem', e.target.value)}
                      disabled={form.tipoEmbalagem !== 'OUTRO'}
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </>
          )}
          <Grid item md={12} sm={12} xs={12}>
            <Autocomplete
              name="setDest"
              value={form.setDest}
              noOptionsText="Sem informações"
              options={setores}
              onChange={(event, newValue) => {
                handleChange('setDest', newValue)
              }}
              getOptionLabel={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
              renderOption={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="SETOR DESTINO"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                />
              )}
            />
          </Grid>
          {form?.setDest?.id === 184 && (
            <>
              <Grid className={classes.item} item md={12} sm={12} xs={12}>
                <Autocomplete
                  name="situacaoVest"
                  value={situacoesVests.find((opt) => opt.slug === form.situacaoVest) || null}
                  noOptionsText="Sem informações"
                  options={situacoesVests}
                   onChange={(event, newValue) => {
                      handleChange('situacaoVest', newValue ? newValue.slug : null)
                  }}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => option.slug === value?.slug}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={'SITUAÇÃO DO VESTÍGIO'}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                    />
                  )}
                />
              </Grid>
            </>
          )}

          {form?.setDest?.id === 184 && form?.situacaoVest == 'PARA_ENTREGA' && (
            <>
              <Grid className={classes.item} item md={12} sm={12} xs={12}>
                <Autocomplete
                  name="setEntregaVest"
                  value={form.setEntregaVest}
                  noOptionsText="Sem informações"
                  options={setores}
                  onChange={(event, newValue) => {
                    handleChange('setEntregaVest', newValue)
                  }}
                  getOptionLabel={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
                  renderOption={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={'SETOR A SER ENTREGUE O VESTÍGIO'}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                    />
                  )}
                />
              </Grid>
            </>
          )}

          <Grid item md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              label="OBSERVAÇÕES"
              name="observacao"
              onChange={(e) => handleChange('observacao', e.target.value)}
              value={form.observacao}
              multiline
            />
          </Grid>
        </>
      )}
    </Grid>
  )
}
